<template lang="pug">
    .re-inp-box__icon.re-inp-box__icon--button(@click="click")
        img(v-if="value" src="/images/client/got-me-hookd/input-icon-eye.svg")
        img(v-else src="/images/client/got-me-hookd/input-icon-eye-crossed.svg")
</template>

<script>
export default {
    name: 're-input-eye-icon',

    props: {
        value: {
            type: Boolean,
            required: true,
        },
    },

    methods: {
        click() {
            this.$emit('input', !this.value)
        },
    },
}
</script>
